function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 122.88 128.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.19 22.46c4 3.23 5.48 3 13 2.49l70.53-4.24c1.5 0 .25-1.49-.25-1.74L92.72 10.5a14.08 14.08 0 0 0-11-3.23l-68.29 5c-2.49.24-3 1.49-2 2.49l9.73 7.72Zm4.23 16.44v74.21c0 4 2 5.48 6.48 5.23l77.52-4.48c4.49-.25 5-3 5-6.23V33.91c0-3.23-1.25-5-4-4.73l-81 4.73c-3 .25-4 1.75-4 5Zm76.53 4c.49 2.24 0 4.48-2.25 4.73l-3.7.73v54.79c-3.24 1.74-6.23 2.73-8.72 2.73-4 0-5-1.24-8-5L54.83 62.55v37.11l7.73 1.74s0 4.48-6.23 4.48l-17.2 1c-.5-1 0-3.48 1.75-4l4.48-1.25V52.59l-6.23-.5a4.66 4.66 0 0 1 4.24-5.73l18.44-1.24L87.24 84V49.6l-6.48-.74a4.21 4.21 0 0 1 4-5l17.21-1ZM7.72 5.52l71-5.23C87.49-.46 89.73.05 95.21 4l22.68 16c3.74 2.74 5 3.48 5 6.47v87.42c0 5.47-2 8.71-9 9.21l-82.5 5c-5.24.25-7.73-.5-10.47-4L4.24 102.4c-3-4-4.24-7-4.24-10.46v-77.7C0 9.76 2 6 7.72 5.52Z",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotion);
export default __webpack_public_path__ + "static/media/notion.f90f3e66f0c05cfa88ae87a7e9c6ee45.svg";
export { ForwardRef as ReactComponent };